(function () {
  function loadEmbed(wrapper) {
    var type = wrapper.getAttribute('data-embed-type');
    var id = wrapper.getAttribute('data-video-id');
    var autoplay = wrapper.getAttribute('data-autoplay') === 'true' ? 1 : 0;
    var loop = wrapper.getAttribute('data-loop') === 'true' ? 1 : 0;
    var mute = wrapper.getAttribute('data-mute') === 'true' ? 1 : 0;
    var controls = wrapper.getAttribute('data-controls') === 'true' ? 1 : 0;
    var target = wrapper.querySelector('.video-section-embed-target');

    if (!target || !id) return;

    var src = '';

    if (type === 'youtube') {
      src = 'https://www.youtube.com/embed/' + id +
        '?autoplay=' + autoplay +
        '&mute=' + (autoplay ? 1 : mute) +
        '&loop=' + loop +
        '&controls=' + controls +
        '&playlist=' + id +
        '&rel=0&playsinline=1';
    } else if (type === 'vimeo') {
      src = 'https://player.vimeo.com/video/' + id +
        '?autoplay=' + autoplay +
        '&muted=' + (autoplay ? 1 : mute) +
        '&loop=' + loop +
        '&controls=' + controls +
        '&playsinline=1';
    }

    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', src);
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('title', 'Video player');

    target.innerHTML = '';
    target.appendChild(iframe);
    target.style.display = 'block';
  }

  function initVideoSections() {
    var sections = document.querySelectorAll('[data-video-section]');

    sections.forEach(function (section) {
      var embedWrap = section.querySelector('.video-section-embed-wrap');
      if (!embedWrap) return;

      var posterBtn = embedWrap.querySelector('.video-section-poster-btn');
      var autoplay = embedWrap.getAttribute('data-autoplay') === 'true';

      if (posterBtn) {
        posterBtn.addEventListener('click', function () {
          loadEmbed(embedWrap);
          posterBtn.remove();
        });
      } else if (autoplay) {
        // No poster image: load immediately if autoplay is requested
        loadEmbed(embedWrap);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoSections);
  } else {
    initVideoSections();
  }

  document.addEventListener('shopify:section:load', initVideoSections);
})();